export const CHARGER_SELECTED = "CHARGER_SELECTED";
